export default __webpack_public_path__ + "static/media/withOptometryOn.7c63f1da.svg";